var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgArrowDown(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 23,
    viewBox: "0 0 22 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Arrow - Down"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 1",
    d: "M5.11957 17.433C4.85109 17.1646 4.82871 16.7432 5.05245 16.4492L5.11957 16.3724L15.7262 5.76579C16.0191 5.47289 16.4939 5.47289 16.7868 5.76579C17.0553 6.03427 17.0777 6.45567 16.854 6.74964L16.7868 6.82645L6.18023 17.433C5.88734 17.7259 5.41247 17.7259 5.11957 17.433Z",
    fill: "#191D23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 3",
    d: "M7.72045 7.06443C7.30624 7.06532 6.96973 6.73026 6.96884 6.31604C6.96803 5.93949 7.24487 5.62715 7.60641 5.5728L7.71722 5.56443L16.2548 5.54605C16.6325 5.54523 16.9454 5.82367 16.9985 6.18643L17.0064 6.2976L16.9888 14.8359C16.9879 15.2501 16.6514 15.5852 16.2372 15.5844C15.8607 15.5836 15.5495 15.3054 15.4967 14.9437L15.4888 14.8328L15.5044 7.04763L7.72045 7.06443Z",
    fill: "#191D23"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowDown);
export default __webpack_public_path__ + "static/media/ArrowDown.a79c9fcbf3eddd8396edf053c77f255d.svg";
export { ForwardRef as ReactComponent };